import {
  Stack,
  styled,
  Typography,
  Box,
  Button,
  Grid,
  Alert,
  AlertTitle,
} from "@mui/material";
import React from "react";
import Iconify from "../iconify/iconify";
import CustomTextField from "../utils/CustomTextField";
import { TextEdit } from "./TextEdit";

import { usePropertiesSlug } from "../../hooks/use-data-properties";
import { useToast } from "../../hooks/use-toast";
import { patch } from "../utils/request";
import { useAuthStore } from "../../stores/authStore";

const StyledBorderStack = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  padding: "35px",
  [theme.breakpoints.down("sm")]: {
    padding: "15px",
  },
  position: "relative",
}));
const StyledKeyBox = styled(Box)(({ theme }) => ({
  background:
    "linear-gradient(90.00deg, rgb(26, 26, 26),rgba(26, 26, 26, 0) 100%)",
  display: "flex",
  alignItems: "center",
  padding: "7px 10px",
  color: theme.palette.text.secondary,
  borderLeft: `2px solid #a95052`,
  gap: "10px",
}));
const StyledBoxEdit = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  color: theme.palette.text.secondary,

  gap: "10px",
}));

export const PropertyDescriptionListEdit = ({ slug }) => {
  const { dataPropertiesSlugQuery } = usePropertiesSlug(slug);
  const { auth } = useAuthStore();
  const [value, setValue] = React.useState("");
  const { toast } = useToast();
  const [descripcionTitle, setDescripcionTitle] = React.useState(
    dataPropertiesSlugQuery?.data?.descriptionList?.descripcionTitle ||
      "Detalles de interiores:"
  );

  const [list, setList] = React.useState(
    dataPropertiesSlugQuery?.data?.descriptionList?.list || [
      "Paredes divisoras con celucreto",
    ]
  );
  const [isEditing, setIsEditing] = React.useState(false);

  const handleSave = async () => {
    try {
      const data = {
        descripcionTitle,
        list,
      };
      await patch({
        path: `/properties/description-list/${slug}`,
        data,
        token: auth.accessToken,
        headers: {
          "Content-Type": "application/json",
        },
      });
      dataPropertiesSlugQuery.refetch();
      setIsEditing(false);
    } catch (error) {
      if (error.response?.status === 400) {
        const data = error.response?.data;
        toast({
          variant: "error",
          title: "Error al actualizar",
          description: data.message[0] || "Ocurrió un error desconocido.",
        });
      }
    }
  };
  return (
    <StyledBorderStack direction="column" gap={2}>
      {isEditing && (
        <Stack
          direction="row-reverse"
          alignItems="center"
          gap={1}
          position={"absolute"}
          top={10}
          right={10}
        >
          <Iconify
            icon="mdi:content-save"
            sx={{
              cursor: "pointer",
              color: "text.secondary",
              fontSize: 400,
              "&:hover": {
                color: "text.primary", // Cambia color al hover
              },
            }}
            onClick={handleSave}
          />
          {/* <Iconify icon="mdi:content-save" sx={{ color: "text.secondary" }} /> */}
        </Stack>
      )}
      <TextEdit
        variant="subtitle1"
        color="text.secondary"
        content={descripcionTitle}
        onSaveChange={(content) => {
          setDescripcionTitle(content);
          setIsEditing(true);
        }}
      />
      {list.map((text, index) => (
        <StyledBoxEdit>
          <Iconify
            icon="mdi:close"
            sx={{ color: "red", cursor: "pointer" }}
            onClick={() => {
              setList(list.filter((item, i) => i !== index));

              setIsEditing(true);
            }}
          />
          <StyledKeyBox key={index}>
            <Iconify icon="ph:lightning-fill" />
            <Typography variant="subtitle1" color="text.secondary">
              {text}
            </Typography>
          </StyledKeyBox>
        </StyledBoxEdit>
      ))}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <CustomTextField
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />{" "}
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: "#a95052",
            "&:hover": { backgroundColor: "#8c3e47" },
          }}
          onClick={() => {
            if (value.length === 0) return;
            if (list.length >= 5) return;

            setList([...list, value]);
            setValue("");
            setIsEditing(true);
          }}
        >
          Enviar Registro
        </Button>
      </Box>
    </StyledBorderStack>
  );
};
